module.exports = __webpack_public_path__ + "img/W3Cx-ch-pix.308102c8.jpg";